module.exports = __webpack_public_path__ + "static/media/mushroom.453ef183.svg";